/**
 * Canonical Typography variant class keys — must match Typography.scss (.ds-*).
 */
export const TYPOGRAPHY_CLASS_KEYS = [
  'headingLarge',
  'headingMedium',
  'headingSmall',
  'bodyLarge',
  'bodyMedium',
  'bodySmall',
  'bodyExtraSmall',
  'captionMedium',
  'codeMedium',
  'codeSmall',
  'displayXLarge',
  'displayLarge',
  'displayMedium',
  'displaySmall',
  'heading2XLarge',
  'headingXLarge',
  't1',
  't2',
  't3',
  't4',
  't5',
  't6',
  't7',
  't8',
  't9',
  't10',
  't11',
  't12',
  't13',
  't14',
  't15',
  't16',
  't17',
  't18',
  't19',
  't20',
  't21',
];

/**
 * Bindings for each `.ds-*` rule in Typography.scss: CSS variable name on `:root`
 * (`--ds-type-*`, `--ds-font-weight-*`) or a literal when SCSS hardcodes the value.
 */
export const TYPOGRAPHY_STYLE_TOKENS = {
  headingLarge: {
    fontSize: '--ds-type-heading-large-fs',
    lineHeight: '26px',
    fontWeight: '--ds-font-weight-semibold',
    letterSpacing: '--ds-type-letter-normal',
  },
  headingMedium: {
    fontSize: '--ds-type-heading-medium-fs',
    lineHeight: '--ds-type-heading-medium-lh',
    fontWeight: '--ds-font-weight-semibold',
    letterSpacing: '--ds-type-letter-normal',
  },
  headingSmall: {
    fontSize: '--ds-type-heading-small-fs',
    lineHeight: '--ds-type-heading-small-lh',
    fontWeight: '--ds-font-weight-semibold',
    letterSpacing: '--ds-type-letter-normal',
  },
  bodyLarge: {
    fontSize: '--ds-type-body-large-fs',
    lineHeight: '--ds-type-body-large-lh',
    fontWeight: '--ds-font-weight-medium',
    letterSpacing: '--ds-type-letter-normal',
  },
  bodyMedium: {
    fontSize: '--ds-type-body-medium-fs',
    lineHeight: '--ds-type-body-medium-lh',
    fontWeight: '--ds-font-weight-medium',
    letterSpacing: '--ds-type-letter-normal',
  },
  bodySmall: {
    fontSize: '--ds-type-body-small-fs',
    lineHeight: '--ds-type-body-small-lh',
    fontWeight: '--ds-font-weight-medium',
    letterSpacing: '--ds-type-letter-normal',
  },
  bodyExtraSmall: {
    fontSize: '--ds-type-body-extra-small-fs',
    lineHeight: '--ds-type-body-extra-small-lh',
    fontWeight: '--ds-font-weight-medium',
    letterSpacing: '--ds-type-letter-normal',
  },
  captionMedium: {
    fontSize: '--ds-type-caption-medium-fs',
    lineHeight: '--ds-type-caption-medium-lh',
    fontWeight: '--ds-font-weight-regular',
    letterSpacing: '--ds-type-letter-normal',
  },
  codeMedium: {
    fontSize: '--ds-type-code-medium-fs',
    lineHeight: '--ds-type-code-medium-lh',
    fontWeight: '--ds-font-weight-regular',
    letterSpacing: '--ds-type-letter-normal',
  },
  codeSmall: {
    fontSize: '--ds-type-code-small-fs',
    lineHeight: '--ds-type-code-small-lh',
    fontWeight: '--ds-font-weight-regular',
    letterSpacing: '--ds-type-letter-normal',
  },
  displayXLarge: {
    fontSize: '--ds-type-display-xlarge-fs',
    lineHeight: '--ds-type-display-xlarge-lh',
    fontWeight: '--ds-font-weight-semibold',
    letterSpacing: '--ds-type-letter-display-tight',
  },
  displayLarge: {
    fontSize: '--ds-type-display-large-fs',
    lineHeight: '--ds-type-display-large-lh',
    fontWeight: '--ds-font-weight-semibold',
    letterSpacing: '--ds-type-letter-display-tight',
  },
  displayMedium: {
    fontSize: '--ds-type-display-medium-fs',
    lineHeight: '--ds-type-display-medium-lh',
    fontWeight: '--ds-font-weight-semibold',
    letterSpacing: null,
  },
  displaySmall: {
    fontSize: '--ds-type-display-small-fs',
    lineHeight: '--ds-type-display-small-lh',
    fontWeight: '--ds-font-weight-semibold',
    letterSpacing: '0',
  },
  heading2XLarge: {
    fontSize: '--ds-type-heading-2xlarge-fs',
    lineHeight: '--ds-type-heading-2xlarge-lh',
    fontWeight: '--ds-font-weight-semibold',
    letterSpacing: '--ds-type-letter-normal',
  },
  headingXLarge: {
    fontSize: '--ds-type-heading-xlarge-fs',
    lineHeight: '--ds-type-heading-xlarge-lh',
    fontWeight: '--ds-font-weight-semibold',
    letterSpacing: '--ds-type-letter-normal',
  },
  t1: {
    fontSize: '--ds-type-t1-fs',
    lineHeight: '--ds-type-t1-lh',
    fontWeight: '--ds-font-weight-semibold',
    letterSpacing: '0',
  },
  t2: {
    fontSize: '--ds-type-t2-fs',
    lineHeight: '--ds-type-t2-lh',
    fontWeight: '--ds-font-weight-semibold',
    letterSpacing: '0',
  },
  t3: {
    fontSize: '--ds-type-t3-fs',
    lineHeight: 'normal',
    fontWeight: '--ds-font-weight-medium',
    letterSpacing: '--ds-type-letter-normal',
  },
  t4: {
    fontSize: '--ds-type-t4-fs',
    lineHeight: 'normal',
    fontWeight: '--ds-font-weight-semibold',
    letterSpacing: '--ds-type-letter-normal',
  },
  t5: {
    fontSize: '--ds-type-t5-fs',
    lineHeight: 'normal',
    fontWeight: '--ds-font-weight-medium',
    letterSpacing: '--ds-type-letter-normal',
  },
  t6: {
    fontSize: '--ds-type-t6-fs',
    lineHeight: 'normal',
    fontWeight: '--ds-font-weight-semibold',
    letterSpacing: '--ds-type-letter-normal',
  },
  t7: {
    fontSize: '--ds-type-t7-fs',
    lineHeight: '--ds-type-t7-lh',
    fontWeight: '--ds-font-weight-medium',
    letterSpacing: '--ds-type-letter-normal',
  },
  t8: {
    fontSize: '--ds-type-t8-fs',
    lineHeight: '--ds-type-t8-lh',
    fontWeight: '--ds-font-weight-semibold',
    letterSpacing: '--ds-type-letter-normal',
  },
  t9: {
    fontSize: '--ds-type-t9-fs',
    lineHeight: '--ds-type-t9-lh',
    fontWeight: '--ds-font-weight-semibold',
    letterSpacing: '--ds-type-letter-normal',
  },
  t10: {
    fontSize: '--ds-type-t10-fs',
    lineHeight: 'normal',
    fontWeight: '--ds-font-weight-medium',
    letterSpacing: '-0.5px',
  },
  t11: {
    fontSize: '--ds-type-t11-fs',
    lineHeight: '--ds-type-t11-lh',
    fontWeight: '--ds-font-weight-semibold',
    letterSpacing: '--ds-type-letter-normal',
  },
  t12: {
    fontSize: '--ds-type-t12-fs',
    lineHeight: '--ds-type-t12-lh',
    fontWeight: '--ds-font-weight-medium',
    letterSpacing: '--ds-type-letter-normal',
  },
  t13: {
    fontSize: '--ds-type-t13-fs',
    lineHeight: '--ds-type-t13-lh',
    fontWeight: '--ds-font-weight-semibold',
    letterSpacing: '--ds-type-letter-normal',
  },
  t14: {
    fontSize: '--ds-type-t14-fs',
    lineHeight: 'normal',
    fontWeight: '--ds-font-weight-medium',
    letterSpacing: '--ds-type-letter-normal',
  },
  t15: {
    fontSize: '--ds-type-t15-fs',
    lineHeight: '--ds-type-t15-lh',
    fontWeight: '--ds-font-weight-medium',
    letterSpacing: '--ds-type-letter-normal',
  },
  t16: {
    fontSize: '--ds-type-t16-fs',
    lineHeight: 'normal',
    fontWeight: '--ds-font-weight-regular',
    letterSpacing: '--ds-type-letter-normal',
  },
  t17: {
    fontSize: '--ds-type-t17-fs',
    lineHeight: '--ds-type-t17-lh',
    fontWeight: '--ds-font-weight-regular',
    letterSpacing: '--ds-type-letter-normal',
  },
  t18: {
    fontSize: '--ds-type-t18-fs',
    lineHeight: '--ds-type-t18-lh',
    fontWeight: '--ds-font-weight-medium',
    letterSpacing: '--ds-type-letter-normal',
  },
  t19: {
    fontSize: '--ds-type-t19-fs',
    lineHeight: 'normal',
    fontWeight: '--ds-font-weight-regular',
    letterSpacing: '--ds-type-letter-normal',
  },
  t20: {
    fontSize: '--ds-type-t20-fs',
    lineHeight: '--ds-type-t20-lh',
    fontWeight: '--ds-font-weight-regular',
    letterSpacing: '--ds-type-letter-normal',
  },
  t21: {
    fontSize: '--ds-type-t21-fs',
    lineHeight: '--ds-type-t21-lh',
    fontWeight: '--ds-font-weight-regular',
    letterSpacing: '--ds-type-letter-normal',
  },
};

/**
 * Legacy Material-style `variant` props → class keys in Typography.scss.
 */
export const LEGACY_TYPOGRAPHY_VARIANT_MAP = {
  h1: 'heading2XLarge',
  h2: 'headingXLarge',
  h3: 'headingMedium',
  h4: 'headingSmall',
  subtitle1: 'headingLarge',
  subtitle2: 'bodyLarge',
  body1: 'bodyMedium',
  body2: 'bodySmall',
  buttonLarge: 'bodyLarge',
  buttonMedium: 'bodyMedium',
  buttonSmall: 'bodySmall',
  caption: 'captionMedium',
};

/** Allowed `variant` prop values (canonical + legacy aliases). */
export const TYPOGRAPHY_VARIANTS = [
  ...new Set([...TYPOGRAPHY_CLASS_KEYS, ...Object.keys(LEGACY_TYPOGRAPHY_VARIANT_MAP)]),
];

export function resolveTypographyClassKey(variant) {
  if (LEGACY_TYPOGRAPHY_VARIANT_MAP[variant]) {
    return LEGACY_TYPOGRAPHY_VARIANT_MAP[variant];
  }
  if (TYPOGRAPHY_CLASS_KEYS.includes(variant)) {
    return variant;
  }
  return 'bodyMedium';
}

/** Default DOM tag when `component` is omitted (by resolved class key). */
export const TYPOGRAPHY_DEFAULT_ELEMENT_BY_CLASS = {
  headingLarge: 'h2',
  headingMedium: 'h3',
  headingSmall: 'h4',
  bodyLarge: 'p',
  bodyMedium: 'p',
  bodySmall: 'p',
  bodyExtraSmall: 'p',
  captionMedium: 'span',
  codeMedium: 'code',
  codeSmall: 'code',
  displayXLarge: 'h1',
  displayLarge: 'h1',
  displayMedium: 'h2',
  displaySmall: 'h2',
  heading2XLarge: 'h1',
  headingXLarge: 'h2',
  t1: 'h1',
  t2: 'h2',
  t3: 'h2',
  t4: 'h3',
  t5: 'h3',
  t6: 'h3',
  t7: 'h4',
  t8: 'h4',
  t9: 'h4',
  t10: 'h5',
  t11: 'p',
  t12: 'p',
  t13: 'p',
  t14: 'p',
  t15: 'p',
  t16: 'p',
  t17: 'p',
  t18: 'p',
  t19: 'p',
  t20: 'p',
  t21: 'p',
};

const PARAGRAPH_MARGIN_BY_CLASS = {
  bodyLarge: 'var(--ds-type-paragraph-body-large)',
  bodyMedium: 'var(--ds-type-paragraph-body-medium)',
  bodySmall: 'var(--ds-type-paragraph-body-small)',
  bodyExtraSmall: 'var(--ds-type-paragraph-body-extra-small)',
};

export function getTypographyParagraphStyle(classKey, paragraph) {
  if (!paragraph || !PARAGRAPH_MARGIN_BY_CLASS[classKey]) {
    return undefined;
  }
  return { marginBottom: PARAGRAPH_MARGIN_BY_CLASS[classKey] };
}

export function getTypographyDefaultComponent(variant, classKey) {
  if (/^button/i.test(variant)) {
    return 'span';
  }
  return TYPOGRAPHY_DEFAULT_ELEMENT_BY_CLASS[classKey] || 'span';
}

export const typography = {
  classKeys: TYPOGRAPHY_CLASS_KEYS,
  legacyVariantMap: LEGACY_TYPOGRAPHY_VARIANT_MAP,
  variants: TYPOGRAPHY_VARIANTS,
  styleTokens: TYPOGRAPHY_STYLE_TOKENS,
};

export default typography;
